export default __webpack_public_path__ + "static/media/login-left-new.b87ee663.svg";